module.exports = __webpack_public_path__ + "img/arrow-right-black.c738c983.svg";